'use client'

import Autoplay from 'embla-carousel-autoplay'
import Image from 'next/image'
import { useCallback, useEffect, useState } from 'react'
import {
  Carousel,
  type CarouselApi,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel'

// import teste from '@/public/img/10.webp'

const comments = [
  '/img/comentarios/coment1.webp',
  '/img/comentarios/coment2.webp',
  '/img/comentarios/coment3.webp',
  '/img/comentarios/coment4.webp',
  '/img/comentarios/coment5.webp',
  '/img/comentarios/coment6.webp',
]

export default function CommentCarousel() {
  const [api, setApi] = useState<CarouselApi>()
  const [currentIndex, setCurrentIndex] = useState(0)
  const [totalItems, setTotalItems] = useState(0)
  const [autoplay] = useState<any>(
    Autoplay({ delay: 10_000, stopOnInteraction: false })
  )

  const scrollPrev = useCallback(() => {
    api?.scrollPrev()
  }, [api])

  const scrollNext = useCallback(() => {
    api?.scrollNext()
  }, [api])

  useEffect(() => {
    if (!api) return

    const updateCarouselState = () => {
      setCurrentIndex(api.selectedScrollSnap())
      setTotalItems(api.scrollSnapList().length)
    }

    updateCarouselState()

    api.on('select', updateCarouselState)

    return () => {
      api.off('select', updateCarouselState) // Clean up on unmount
    }
  }, [api])

  const scrollToIndex = (index: number) => {
    api?.scrollTo(index)
  }

  return (
    <div className="relative bg-[#5f6ff4] pt-12 pb-10">
      <div className="container">
        <div className="text-white">
          <span className="text-lg">AVALIAÇÕES DE ALUNOS</span>
          <h1 className="mt-2 font-bold text-5xl">O Mais Recomendado</h1>
        </div>

        <Carousel
          className="mt-6 w-full"
          opts={{ loop: true }}
          plugins={[autoplay]}
          setApi={setApi}
        >
          <CarouselContent>
            {comments.map(comment => (
              <CarouselItem className="md:basis-1/2 lg:basis-1/3" key={comment}>
                <Image
                  alt=""
                  className="rounded-xl"
                  height={155}
                  src={comment}
                  width={465}
                />
              </CarouselItem>
            ))}
          </CarouselContent>

          <div className="absolute right-0 left-0 z-20 mt-3 flex justify-center space-x-2">
            {Array.from({ length: totalItems }).map((_, index) => (
              <button
                className={`h-3 w-3 rounded-full ${
                  currentIndex === index ? 'bg-[#A3A3A3]' : 'bg-[#E5E5E5]'
                }`}
                key={index}
                onClick={() => scrollToIndex(index)}
                type="button"
              />
            ))}
          </div>
        </Carousel>
      </div>
    </div>
  )
}
